/**
 * The backend stores only the username (e.g. "john.doe" or "jdoe").
 * Convert dot/underscore-separated usernames to Title Case where possible.
 * Single tokens (e.g. "jdoe") are returned as-is.
 */
export function formatUsername(raw?: string | null): string {
  if (!raw) return "System";
  const parts = raw.split(/[._]/).filter(Boolean);
  if (parts.length < 2) return raw; // can't infer display name from single token
  return parts.map((p) => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()).join(" ");
}
